import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import {BehaviorSubject, Subject} from "rxjs";
import { Observable } from "rxjs";
import {map, shareReplay, tap} from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import * as Cookies from 'js-cookie';
import {ConstantsService as constants} from "../../services/constants/constants.service";

export interface planState{
    current_time:any,
    valid_from:any,
    valid_till:any,
    user_role:any,
    type:any,
    message:any,
    active:any,
    payment_status:any,
    is_non_cb_trial:boolean,
    remaining_profile_credits:number
}
@Injectable({
    providedIn: 'root'
  })
export class PlanService {
    planState:planState = {
        current_time:' ',
        valid_from:' ',
        valid_till:' ',
        user_role:' ',
        type:' ',
        message:' ',
        active:' ',
        payment_status:' ',
        is_non_cb_trial:false,
        remaining_profile_credits:0
    }
    requestGuard = false as any;
    private sfdcIdSubject = new BehaviorSubject<any>(null);
    private sfdcId$ = this.sfdcIdSubject.asObservable();
    private renewalStatus$: Observable<any> | null = null;
    private renewalStatusOrgUid: string | undefined;

    constructor(private apiservice: ApiService){
    }
    getPlan(filteredPlans):any {
        let params = new HttpParams().set('filteredPlans', filteredPlans)
        const endpoint = `organisation/plan`
        return this.apiservice.get(endpoint, {params: params}).pipe(map(data => data));
    }

    // Requested at most once per organisation per page load; the response calls Chargebee.
    getRenewalStatus(): Observable<any> {
        const orgUid = Cookies.get(constants.ORG_COOKIE);
        if (!this.renewalStatus$ || this.renewalStatusOrgUid !== orgUid) {
            this.renewalStatusOrgUid = orgUid;
            this.renewalStatus$ = this.apiservice.get(`organisation/plan/renewal-status`).pipe(shareReplay(1));
        }
        return this.renewalStatus$;
    }

    postLog(data): any{
        const endpoint = `log_request/`
        return this.apiservice.post(endpoint, data).pipe(map(data => data));
    }

    deprecatedGetSFDCid():any{
        const endpoint = `organisation/sfdc_id`
        return this.apiservice.get(endpoint).pipe(map(data=>data))
    }
    getSFDCid(): Observable<any> {
    if (!this.sfdcIdSubject.value) {
      const endpoint = `organisation/sfdc_id`;
      this.apiservice.get(endpoint).pipe(
        map(data => data),
        tap(data => this.sfdcIdSubject.next(data))
      ).subscribe();
    }
    return this.sfdcId$;
  }
    setPlan(state):any{
        this.planState.current_time = state.current_time
        this.planState.user_role = state.role,
        this.planState.message = state.message,
        this.planState.type = state.type
        this.planState.valid_from = state.valid_start_time
        this.planState.valid_till = state.valid_end_time
        this.planState.current_time = state.current_time
        this.planState.active = state.active
        this.planState.payment_status = state.payment_status
        this.planState.is_non_cb_trial = state.is_non_cb_trial
        this.planState.remaining_profile_credits = state.remaining_profile_credits
        return this.planState
    }
    setGuard(guard){
        this.requestGuard = guard
        return this.requestGuard
    }

    getGuard(){
        return this.requestGuard
    }
    getPlanState(){
        return this.planState
    }

    isTrialCreditsExhausted(): boolean {
        return this.planState.is_non_cb_trial && this.planState.remaining_profile_credits <= 0;
    }
}
